import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class SinglePost {
    constructor() {
        this.article = document.querySelector('.blog-single');
        this.pinTarget = document.querySelector('.blog-single__media-pin');
        this.image = document.querySelector('.blog-single__image');
        this.header = document.getElementById('header');

        this.init();
    }

    init() {
        if (!this.article || !this.pinTarget || !this.image) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        const article = this.article;
        const pinTarget = this.pinTarget;
        const header = this.header;

        ScrollTrigger.matchMedia({
            '(min-width: 901px)': function () {
                if (article.offsetHeight <= pinTarget.offsetHeight + 1) {
                    return;
                }

                ScrollTrigger.create({
                    trigger: pinTarget,
                    start: () => 'top ' + (header ? header.offsetHeight : 87) + 'px',
                    endTrigger: article,
                    end: () =>
                        'bottom ' +
                        ((header ? header.offsetHeight : 87) + pinTarget.offsetHeight) +
                        'px',
                    pin: true,
                    pinSpacing: false,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                });

                requestAnimationFrame(function () {
                    ScrollTrigger.refresh();
                });
            },
        });

        window.addEventListener('load', function () {
            ScrollTrigger.refresh();
        });
    }
}

export { SinglePost };
